import AllAssetsActionTypes from './allAssets-types'

const INITIAL_STATE = {
    allAssets: null,
    error: null,
    loader: null,
    quickDepositAsset: null,
}

const allAssetsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AllAssetsActionTypes.START_FETCH_ALL_ASSETS:
            return {
                ...state,
                loader: { ...state.loader, FETCH_ALL_ASSETS: true },
            }
        case AllAssetsActionTypes.SUCCESS_FETCH_ALL_ASSETS:
            return {
                ...state,
                allAssets: action.payload,
                loader: { ...state.loader, FETCH_ALL_ASSETS: null },
            }
        case AllAssetsActionTypes.FAILURE_FETCH_ALL_ASSETS:
            return {
                ...state,
                error: { ...state.error, FETCH_ALL_ASSETS: true },
            }
        case AllAssetsActionTypes.FINISH_FETCH_ALL_ASSETS:
            return {
                ...state,
                error: { ...state.error, FETCH_ALL_ASSETS: null },
            }

        case AllAssetsActionTypes.START_GET_QUICK_DEPOSIT_ASSET:
            return {
                ...state,
                loader: { ...state.loader, GET_QUICK_DEPOSIT_ASSET: true },
            }
        case AllAssetsActionTypes.SUCCESS_GET_QUICK_DEPOSIT_ASSET:
            return {
                ...state,
                quickDepositAsset: state.quickDepositAsset ?? action.payload,
                loader: { ...state.loader, GET_QUICK_DEPOSIT_ASSET: null },
                error: { ...state.error, GET_QUICK_DEPOSIT_ASSET: null },
            }
        case AllAssetsActionTypes.FAILURE_GET_QUICK_DEPOSIT_ASSET:
            return {
                ...state,
                quickDepositAsset: null,
                loader: { ...state.loader, GET_QUICK_DEPOSIT_ASSET: null },
                error: { ...state.error, GET_QUICK_DEPOSIT_ASSET: true },
            }
        case AllAssetsActionTypes.FINISH_GET_QUICK_DEPOSIT_ASSET:
            return {
                ...state,
                quickDepositAsset: null,
                loader: { ...state.loader, GET_QUICK_DEPOSIT_ASSET: null },
                error: { ...state.error, GET_QUICK_DEPOSIT_ASSET: null },
            }

        default:
            return state
    }
}

export default allAssetsReducer
